module.exports = __webpack_public_path__ + "img/128.caaa194c.jpg";